import {useEffect, useState} from "react";
import {Calendar} from "../system/calendar/calendar";
import {getAgentMonthSchedule, submitSchedule, updateSchedule} from "../../services/schedule/schedule";
import jalaali from "jalaali-js";


export function ScheduleManagement() {

  const [schedules, setSchedules] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(Date.now)

  async function getData(jy, jm, monthDays) {
    const result = await getAgentMonthSchedule(jy, jm, monthDays);
    if (result.status === 200) {
      const {scheduleList} = result.data;
      setSchedules(scheduleList || []);
    }
  }

  useEffect(() => {
    const {jy, jm} = jalaali.toJalaali(new Date())
    const monthDays = jalaali.jalaaliMonthLength(jy, jm);
    getData(jy, jm, monthDays);
  }, [lastDataRefresh]);

  const save = async (id, title, from, to, startDate, endDate, weekDayId) => {
    const data = {
      id: id,
      title: title,
      start_time: from,
      end_time: to,
      start_date: startDate,
      end_date: endDate,
      week_day_id: weekDayId,
    };
    let result;

    if (!id) {
      result = await submitSchedule(data);
    } else {
      result = await updateSchedule(data);
    }

    if (result.status === 200) {
      setLastDataRefresh(Date.now())
    }

  };

  return (
    <div className="w-full">
      <Calendar
        Type="schedule"
        eventList={schedules}
        setEventList={setSchedules}
        setLastDataRefresh={setLastDataRefresh}
        lastDataRefresh={lastDataRefresh}
        onEvent={(id, title, from, to, startDate, endDate, weekDayId) => {
          save(id, title, from, to, startDate, endDate, weekDayId)
        }}
        onNavigate={(jy, jm, monthDays) => {
          getData(jy, jm, monthDays);
        }}
      />
    </div>
  );
}